import { useState, useEffect } from "react";

export default function DealTimer({ endTime }) {
  function calculateTimeLeft() {
    const diff = new Date(endTime) - new Date();

    if (diff <= 0) {
      return { hours: 0, minutes: 0, seconds: 0, total: 0 };
    }

    const hours = Math.floor(diff / (1000 * 60 * 60));
    const minutes = Math.floor((diff / (1000 * 60)) % 60);
    const seconds = Math.floor((diff / 1000) % 60);

    return { hours, minutes, seconds, total: diff };
  }

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  useEffect(() => {
    const timer = setInterval(() => {
      const updated = calculateTimeLeft();
      setTimeLeft(updated);

      // stop when it reaches 0
      if (updated.total <= 0) {
        clearInterval(timer);
        window.dispatchEvent(new Event("deal-ended")); // optional
      }
    }, 1000);

    return () => clearInterval(timer);
  }, [endTime]);

  return (
    <div className="deal-timer">
      <span className="timer-unit">{timeLeft.hours}h</span>
      <span className="timer-unit">{timeLeft.minutes}m</span>
      <span className="timer-unit">{timeLeft.seconds}s</span>
    </div>
  );
}